"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var R = _interopRequireWildcard(require("ramda"));
var _utils = require("@trs/utils");
var _button = require("../../button");
var _icon = _interopRequireDefault(require("../../icon"));
var _BlockWrapper = _interopRequireDefault(require("./BlockWrapper"));
var _Searchable = _interopRequireDefault(require("../Searchable"));
var _Age = _interopRequireDefault(require("./Age"));
var _Toolbox = _interopRequireDefault(require("../Toolbox"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getInteractionType = function getInteractionType(thresholds) {
  if (thresholds.isBetween) return 'between';
  var min = R.prop('min', thresholds);
  var max = R.prop('max', thresholds);
  if (min && max) return 'between';
  if (min) return thresholds.isInclusive ? '>=' : '>';
  if (max) return thresholds.isInclusive ? '<=' : '<';
  if (min === null && max === null) return 'empty';
  return '';
};
var ThresholdMember = /*#__PURE__*/function (_React$Component) {
  function ThresholdMember(props) {
    var _this;
    _classCallCheck(this, ThresholdMember);
    _this = _callSuper(this, ThresholdMember, [props]);
    _defineProperty(_this, "clearFocus", function () {
      _this.setState({
        isFocused: false
      });
    });
    _this.state = {
      isFocused: false
    };
    return _this;
  }
  _inherits(ThresholdMember, _React$Component);
  return _createClass(ThresholdMember, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var isFocused = this.state.isFocused;
      var _this$props = this.props,
        disabled = _this$props.disabled,
        labels = _this$props.labels,
        blockType = _this$props.blockType,
        thresholds = _this$props.thresholds,
        ruleIndex = _this$props.ruleIndex,
        thresholdIndex = _this$props.thresholdIndex,
        actions = _this$props.actions,
        thresholdRowIndex = _this$props.thresholdRowIndex,
        blockData = _this$props.blockData;
      var andData = R.path(['thresholdRows', 1], thresholds);
      var interactionType = getInteractionType(blockData);
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "threshold-block",
        onClick: function onClick() {
          return _this2.setState({
            isFocused: true
          });
        },
        role: "button",
        tabIndex: 0,
        onBlur: this.clearFocus,
        onKeyPress: function onKeyPress() {
          return _this2.setState({
            isFocused: true
          });
        }
      }, /*#__PURE__*/_react["default"].createElement("strong", {
        className: "threshold-element threshold-header"
      }, (0, _utils.toUpper)(blockType === 'if' ? labels.PENSION_PENSIONABLE_SALARY_IF_LABEL : labels.PENSION_PENSIONABLE_SALARY_AND_LABEL)), isFocused && blockType !== 'if' && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button delete-member",
        onMouseDown: function onMouseDown(ev) {
          var morphedData = R.clone(thresholds);
          ev.stopPropagation();
          morphedData.thresholdRows.splice(1);
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-android-delete",
        size: 14
      })), /*#__PURE__*/_react["default"].createElement("span", {
        className: "threshold-element"
      }, blockType === 'if' ? /*#__PURE__*/_react["default"].createElement(_Searchable["default"], {
        disabled: true,
        id: "".concat(ruleIndex, "-threshold-pensionable-label"),
        keysPath: [],
        description: labels.PENSION_PENSIONABLE_SALARY_DESCRIPTION,
        error: null,
        labels: labels,
        formulaChange: function formulaChange() {},
        displayName: labels.PENSION_PENSIONABLE_SALARY_LABEL,
        value: labels.PENSION_PENSIONABLE_SALARY_LABEL,
        searchableAction: function searchableAction() {}
      }) : /*#__PURE__*/_react["default"].createElement(_Age["default"], {
        disabled: disabled,
        id: "".concat(ruleIndex, "-age-").concat(thresholdIndex),
        className: "threshold-element",
        ageType: blockData.field,
        isFocused: false,
        date: blockData.date || new Date(),
        onChangeAgeType: function onChangeAgeType(update) {
          var morphedData = R.clone(thresholds);
          morphedData.thresholdRows[1].field = update.value;
          if (update.value === 'age-on-date') {
            morphedData.thresholdRows[1].date = (0, _utils.offsetTimezone)();
          }
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
          _this2.clearFocus();
        },
        onChangeDate: function onChangeDate(date) {
          var morphedData = R.clone(thresholds);
          morphedData.thresholdRows[1].date = date;
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
        }
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "threshold-block-thresholds threshold-element ".concat(interactionType === 'between' ? 'threshold-block-function' : '')
      }, /*#__PURE__*/_react["default"].createElement(_BlockWrapper["default"], _extends({
        blockData: blockData,
        blockType: blockType,
        data: thresholds,
        interactionType: interactionType,
        isFocused: isFocused,
        thresholdRowIndex: thresholdRowIndex,
        andData: andData,
        clearFocus: this.clearFocus
      }, this.props))), isFocused && blockType !== 'and' && !andData && interactionType !== 'between' && /*#__PURE__*/_react["default"].createElement(_button.Button, {
        disabled: disabled,
        className: "formula-button add-member",
        onMouseDown: function onMouseDown(ev) {
          var morphedData = R.clone(thresholds);
          ev.stopPropagation();
          morphedData.thresholdRows.push({
            field: 'age',
            min: null,
            max: null,
            date: null
          });
          actions.thresholdChange('update', {
            thresholdIndex: thresholdIndex,
            thresholdData: morphedData
          });
          _this2.clearFocus();
        },
        type: "naked"
      }, /*#__PURE__*/_react["default"].createElement(_icon["default"], {
        icon: "ion-plus",
        size: 14
      })), isFocused && interactionType !== 'between' && /*#__PURE__*/_react["default"].createElement(_Toolbox["default"], _extends({}, this.props, {
        noFunctions: true,
        noBetween: false,
        noGroups: true,
        functionsEnabled: true,
        paranthesesEnabled: true,
        focusedPath: [],
        betweenEnabled: true,
        keysPath: [],
        clearFocus: this.clearFocus
      })));
    }
  }]);
}(_react["default"].Component);
ThresholdMember.defaultProps = {
  errors: {},
  disabled: false,
  blockType: '',
  thresholdRowIndex: 0,
  blockData: {}
};
ThresholdMember.propTypes = {
  blockData: _propTypes["default"].shape({}),
  thresholdRowIndex: _propTypes["default"].number,
  blockType: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  /* The threshold index */
  thresholdIndex: _propTypes["default"].number.isRequired,
  /* The rule index */
  ruleIndex: _propTypes["default"].number.isRequired,
  /* The rewards labels */
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  /* The root thresholds for each threshold */
  thresholds: _propTypes["default"].shape({}).isRequired,
  /* The errros object */
  errors: _propTypes["default"].shape({}),
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired
};
var _default = exports["default"] = ThresholdMember;